import { useEffect, useState } from "react";

// The time as of now, moved on once when core's check expires, so an open card drops the line by itself.
export function useNowUntilExpiry(expiresAt: number | null): number {
    const [now, setNow] = useState(Date.now);

    useEffect(() => {
        if (expiresAt === null || expiresAt <= Date.now()) {
            return;
        }
        const timer = setTimeout(() => setNow(Date.now()), expiresAt - Date.now());

        return () => clearTimeout(timer);
    }, [expiresAt]);

    return now;
}
